import {
    AfterViewInit,
    Component,
    HostListener,
    OnDestroy,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TwilioService } from '../../services/twilio.service';
import { bufferCount, distinctUntilChanged, filter, first, map, mergeMap, takeUntil } from 'rxjs/operators';
import {
    CallLogsSearchParams,
    CustomerSearchParams,
    defaultCallLogsSearchParams,
    defaultCustomerSearch,
    defaultOrderSearchParams,
} from '../../data-types/search-params';
import { Store } from '../../store';
import { OrdersService } from '../../services/orders.service';
import { NavigationEnd, Router } from '@angular/router';
import { ReplaySubject, Subject, Subscription, take } from 'rxjs';
import { defaultVoiceContactData, DeviceState, TwilioEvents, VoiceContactData } from '../../data-types/voice-data';
import { AlertConfirmData, defaultAlertConfirmData } from '../../data-types/alert-data';
import { AlertService } from 'src/app/services/alert.service';
import { AlertConfirmable } from '../../decorators/alert-confirmable.decorator';
import { UserService } from '../../services/user.service';
import { MenuService } from '../../services/menu.service';
import { CallAiAssistState, CallDataType, defaultCallAiAssistState, defaultCallData, defaultCallDataToggle } from '../../state';
import { SubMenuBase } from '../../models/menu-item';
import { debounce } from 'lodash';
import { environment as env } from '../../../environments/environment';
import { Notes, NoteType } from '../../models/notes';
import { NotesService } from '../../services/notes.service';
import { CdkDrag } from '@angular/cdk/drag-drop';
import { IUserSelectorSettings } from 'src/app/chat/dialogs/user-selector-dlg/user-selector-dlg.interface';
import { RowActionType, TableConfig } from '../../models/table-config';
import {
    LiveCallsRow,
    TwilioAgentModel,
    TwilioCallStats,
    TwilioQueueState,
    TwilioQueueStatus
} from '../../models/calls';
import { Socket } from 'ngx-socket-io';
import { formatDistanceToNow } from 'date-fns';
import { ToastrService } from 'ngx-toastr';
import { User } from '../model/model';
import { ToolsService } from '../../services/tools.service';

type callCenterMode =
    | 'bar-style'
    | 'floating-window'
    | 'full-screen-window'
    | 'full-screen-window--contacts'
    | 'full-screen-window--calls'
    | 'full-screen-window--settings'
    | 'none';
type onOff = 1 | 0;
type tabsOnOff = [onOff, onOff, onOff, onOff, onOff, onOff];
type floatTabsOnOff = [onOff, onOff, onOff];

@Component({
    selector: 'app-call-center',
    templateUrl: './call-center.component.html',
    styleUrls: ['./call-center.component.scss'],
    animations: [
        trigger('fadeInOut', [
            state('void', style({ opacity: '0' })),
            transition('void => *', [animate('150ms ease-out')]),
            state('*', style({ opacity: '1' })),
            transition('* => void', [animate('50ms ease-in')]),
        ]),
        trigger('slideDetails', [
            state(
                'void',
                style({
                    height: 0,
                    opacity: 0.6,
                })
            ),
            transition('void => *', [animate('150ms ease-in')]),
            state(
                '*',
                style({
                    opacity: 1,
                    height: '470px',
                })
            ),
            transition('* => void', [animate('50ms ease-in')]),
        ]),
    ],
})
export class CallCenterComponent implements OnInit, AfterViewInit, OnDestroy {
    @Output() floatingBar = null;
    @Output() callBar = null;

    userSelectorSettings: IUserSelectorSettings = {
        mode: 'single',
        showTypeSelector: true,
        selectByClick: true,
        showUserPhones: true,
        style: 'dailer-contacts',
    };
    user: User = this.store.selectForLocal<User>('user');
    callDetails$ = this.store.select<CallDataType>('call');
    contactList = [];
    loadContactsDebounce;
    params: CustomerSearchParams = { ...defaultCustomerSearch };
    private loadContactsDebounce$ = new Subject<Subscription>();

    loadCustomerCallsDebounce;
    private loadCustomerCallsDebounce$ = new Subject<Subscription>();

    agentsList = []; // only for domain
    agentsListAll = []; // absolutely all
    filteredAgentsList = [];
    agentFilter = '';
    redirect2Agent = null;
    filterAgentListDebounce;

    uploadConfig = {
        url: env.imageUploadPath + 'notes/upload',
        parallelUploads: 3,
        maxFiles: 10,
        maxFilesize: 5120,
        params: {},
        // The API's upload routes now require the admin session: send the cookie and
        // the app-name the API uses to pick auth.app.admin (Dropzone bypasses the interceptor).
        withCredentials: true,
        headers: {
            'api-key': '6bf9284a-ebf9-4afa-a185-4d2b9bb29e85',
            'app-name': 'admin',
        },
    };
    env = env;
    tinyInit = {
        height: 200,
        placeholder: 'Enter Note',
        menubar: false,
        plugins: ['preview anchor', 'searchreplace visualblocks link image imagetools'],
        toolbar:
            'undo redo | formatselect | bold italic | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist | removeformat |visualblocks',
    };
    canPostANote = true;
    callNoteData = {
        files: [],
        content: '',
    };

    @ViewChild('floatTemplate', { read: TemplateRef }) floatTemplate: TemplateRef<any>;
    @ViewChild('barTemplate', { read: TemplateRef }) barTemplate: TemplateRef<any>;
    @ViewChild('windowTemplate', { read: TemplateRef }) windowTemplate: TemplateRef<any>;
    @ViewChild('tooltipTemplate', { read: TemplateRef }) tooltipTemplate: TemplateRef<any>;

    @ViewChild('cdkDrag', { read: CdkDrag }) cdkDrag: CdkDrag;
    dragPosition = { x: 0, y: 0 };

    private _activeFloatTabI: floatTabsOnOff = [1, 0, 0];
    private _activeTabI: tabsOnOff = [1, 0, 0, 0, 0, 0];
    private _centerMode: callCenterMode = 'none';

    callLogsParams: CallLogsSearchParams = { ...defaultCallLogsSearchParams, limit: 30 };
    destroy$ = new Subject<void>();
    subs$ = new ReplaySubject();
    callLogs = [];
    searchPhoneNr = '';
    inFocus = false;
    callStats: TwilioCallStats; // gudeleviciene

    public liveCallsRows: LiveCallsRow[];
    public tableConfig: TableConfig<LiveCallsRow>;
    private voiceSocket: Socket; // here comes all sorts of messages from CRM

    agentOnlineCb = (agent) => agent.inbound && Date.now() < new Date(agent.inbound).getTime() || (agent.availableForInbound && agent.altPhone);
    availableForInboundAgentCb = (agent) => agent.inbound && Date.now() < new Date(agent.inbound).getTime();

    @HostListener('document:click', ['$event'])
    documentClick(btn) {
        this.inFocus = false;
    }

    public tabMenuItems: SubMenuBase[] = [
        {
            title: 'Dialer',
            active: true,
            id: 0,
        } as SubMenuBase,
        {
            title: 'Call History',
            active: false,
            id: 1,
        } as SubMenuBase,
        {
            title: 'Contacts',
            active: false,
            id: 2,
        } as SubMenuBase,
        {
            title: 'Recordings',
            active: false,
            id: 3,
        } as SubMenuBase,
        {
            title: 'Voicemail',
            active: false,
            id: 4,
        } as SubMenuBase,
        {
            title: 'Call settings',
            active: false,
            id: 5,
        } as SubMenuBase,
    ];

    toastRef;
    callBackRows;
    callbackPaused = false;

    constructor(
        public twilioService: TwilioService,
        public notesService: NotesService,
        public store: Store,
        private ordersService: OrdersService,
        private router: Router,
        private alertService: AlertService,
        private userService: UserService,
        private menuService: MenuService,
        private toastrService: ToastrService,
        public toolsService: ToolsService,
    ) {
        this.callLogsParams.customerId = this.user.id;

        this.loadCustomerCallsDebounce = debounce(this.loadCustomerCalls, 350);
        this.loadCustomerCallsDebounce$.pipe(bufferCount(2, 1)).subscribe(([oldSub, newSub]) => oldSub.unsubscribe());

        this.loadContactsDebounce = debounce(this.loadContacts, 350);
        this.loadContactsDebounce$.pipe(bufferCount(2, 1)).subscribe(([oldSub, newSub]) => oldSub.unsubscribe());

        this.filterAgentListDebounce = debounce(this.filterAgentList, 350);
        this.forceIntoTheBox = debounce(this.forceIntoTheBox, 100);
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                map(({ url }: any) => url),
                distinctUntilChanged(),
                filter(
                    () =>
                        [
                            'full-screen-window',
                            'full-screen-window--contacts',
                            'full-screen-window--calls',
                            'full-screen-window--settings',
                        ].indexOf(this.callCenterMode) !== -1
                )
            )
            .subscribe((event) => (this.callCenterMode = 'floating-window'));
        this.twilioService.serviceEvents$$
            .pipe(
                takeUntil(this.destroy$),
                filter(item => item === TwilioEvents.SHOW_TWILIO_SETTINGS)
            )
            .subscribe(() => (this.callCenterMode = 'full-screen-window--settings'));
    }

    ngOnDestroy(): void {
        this.voiceSocket?.disconnect();
        this.voiceSocket = undefined;
        this.destroy$.next();
    }

    ngOnInit(): void {
        this.store.select<boolean>('loggedIn')
            .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
            .subscribe((status) => {
                if (status === true) {
                    if (this.twilioService.disabled === true) {
                        this.twilioService.initTwilio(this.user);
                    }
                    return;
                }

                this.twilioService.disabled = true;
                this.callCenterMode = 'none';
            });

        this.twilioService.onLineContact$$
            .pipe(
                filter((data) => data === null && this.twilioService.isInboundCall), // only for inbound call
                takeUntil(this.destroy$)
            )
            .subscribe(() => {
                this.twilioService.onLinePhoneNr$$.pipe(filter((phone: any) => phone), first()).subscribe((toPhone) => {
                    this.store.set('call', { ...defaultCallData });

                    if (this.twilioService.inboundCall.parameters.From.indexOf('client') === -1) {
                        this.twilioService
                            .searchContacts(toPhone)
                            .pipe(filter((result) => !!result))
                            .subscribe((contactResult) => {
                                this.twilioService.contact = contactResult;
                                this.store.setProp<CallDataType>('call', { contact: contactResult });

                                this.ordersService
                                    .searchOrderDetails({
                                        ...defaultOrderSearchParams,
                                        customerId: contactResult.id,
                                    })
                                    .subscribe((orderResult) => {
                                        if (orderResult.data.length > 0) {
                                            this.store.setProp('call', { orders: orderResult.data });
                                        }
                                    });
                            });
                    } else {
                        this.twilioService
                            .getContact(this.twilioService.inboundCall.parameters.From.split(':')[1])
                            .pipe(filter((result) => !!result))
                            .subscribe((contactResult) => {
                                this.twilioService.contact = contactResult;
                                this.store.setProp<CallDataType>('call', { contact: contactResult });

                                this.ordersService
                                    .searchOrderDetails({
                                        ...defaultOrderSearchParams,
                                        customerId: contactResult.id,
                                    })
                                    .subscribe((orderResult) => {
                                        if (orderResult.data.length > 0) {
                                            this.store.setProp('call', { orders: orderResult.data });
                                        }
                                    });
                            });
                    }
                });
            });

        this.twilioService.deviceState$
            .pipe(takeUntil(this.destroy$))
            .subscribe((deviceState) => {
            if (deviceState === DeviceState.INCOMING || deviceState === DeviceState.OUTGOING) {
                this.setCallAiAssist({
                    ...defaultCallAiAssistState,
                    status: 'matching',
                    updatedAt: new Date().toISOString(),
                });
                if (this.callCenterMode === 'none') {
                    this.callCenterMode = 'bar-style';
                }
                // making sure when call comes in that only dialer is visible
                this.activateTab = 0;
                this.activeFloatTabI = [1, 0, 0];
            }

            if (deviceState === DeviceState.INBOUND || deviceState === DeviceState.OUTBOUND) {
                this.setCallAiAssist({
                    status: 'listening',
                    updatedAt: new Date().toISOString(),
                });
                this.notesService
                    .getNotesEndsWithRecordId(NoteType.Calls, this.twilioService.callCustomerNumber ?? this.twilioService.callUniqueId)
                    .subscribe((data) => this.store.setProp<CallDataType>('call', { notes: data }));
            }

            if (deviceState === DeviceState.IDLE) {
                this.store.set('call', { ...defaultCallData });
                if (this.callCenterMode === 'bar-style') {
                    this.callCenterMode = 'none';
                }
            }
        });

        // available agents
        this.twilioService.phoneList.pipe(takeUntil(this.destroy$)).subscribe((list) => this.filterAgentList(list));

        this.voiceSocket = new Socket({ url: `${env.socketPath}voice`, options: { withCredentials: true } });
        this.voiceSocket.on('connect', () => {
            this.voiceSocket.fromEvent('queue-row')
                .pipe(map((item: any) => ({
                    ...item,
                    createdAt: new Date(item.createdAt),
                    data: JSON.parse(item.data),
                    log: JSON.parse(item.log) as Array<string>,
                } as LiveCallsRow)))
                .subscribe((callRow: LiveCallsRow) => {
                    if (this.liveCallsRows && this.callCenterMode === 'full-screen-window') { // updating only on full screen view
                        const index = this.liveCallsRows.findIndex(item => item.id === callRow.id);
                        if (index !== -1) {
                            this.liveCallsRows.splice(index, 1, callRow);
                        } else {
                            this.liveCallsRows.unshift(callRow);
                        }
                    }
                });
            this.voiceSocket
                .fromEvent('call-statistics')
                .subscribe((callStats: TwilioCallStats) => this.callStats = callStats);


            this.voiceSocket
                .fromEvent<LiveCallsRow[]>('callback-requests')
                .subscribe((callBackRows: LiveCallsRow[]) => {
                    this.callBackRows = callBackRows;
                    if (this.callbackPaused || this.twilioService.isLineBusy) {
                        return;
                    }

                    if (this.callBackRows.length > 0) {
                        this.showCallbackRequest(this.callBackRows[0]);
                    }
                });
            this.voiceSocket
                .fromEvent<LiveCallsRow>('void-callback-request')
                .subscribe((callBackRow: LiveCallsRow) => {
                    this.toastrService.clear(this.toastRef.id);
                    this.callBackRows = this.callBackRows.filter(item => item.id !== callBackRow.id);
                    if (this.callBackRows.length > 0) {
                        this.showCallbackRequest(this.callBackRows[0]);
                    }
                });
            this.voiceSocket
                .fromEvent<any>('call-ai-assist')
                .subscribe((event) => this.handleCallAiAssistEvent(event));
            this.voiceSocket
                .fromEvent<any>('call-transcript')
                .subscribe((event) => this.handleCallTranscriptEvent(event));
            this.voiceSocket
                .fromEvent<any>('call-price-match')
                .subscribe((event) => this.handleCallPriceMatchEvent(event));
        });
    }

    private handleCallAiAssistEvent(event: any): void {
        if (!this.isCurrentCallEvent(event)) {
            return;
        }

        const aiAssist: Partial<CallAiAssistState> = {
            status: event.status || 'ready',
            intent: event.intent || '',
            confidence: event.confidence ?? null,
            suggestedReply: event.suggestedReply || event.suggested_reply || '',
            updatedAt: event.updatedAt || new Date().toISOString(),
        };

        if (Array.isArray(event.transcript)) {
            aiAssist.transcript = event.transcript;
        }
        if (Array.isArray(event.priceMatches)) {
            aiAssist.priceMatches = event.priceMatches;
        }
        if (Array.isArray(event.actionCandidates)) {
            aiAssist.actionCandidates = event.actionCandidates;
        }

        this.setCallAiAssist(aiAssist);
    }

    private handleCallTranscriptEvent(event: any): void {
        if (!this.isCurrentCallEvent(event)) {
            return;
        }

        const call = this.store.selectForLocal<CallDataType>('call');
        const currentTranscript = call?.aiAssist?.transcript || [];
        const text = event.text || event.transcript || event.TranscriptionText;

        if (!text) {
            return;
        }

        this.setCallAiAssist({
            status: 'listening',
            transcript: [
                ...currentTranscript,
                {
                    speaker: event.speaker || event.participant || 'customer',
                    text,
                    partial: !!event.partial,
                    createdAt: event.createdAt || new Date().toISOString(),
                },
            ].slice(-20),
            updatedAt: new Date().toISOString(),
        });
    }

    private handleCallPriceMatchEvent(event: any): void {
        if (!this.isCurrentCallEvent(event)) {
            return;
        }

        const call = this.store.selectForLocal<CallDataType>('call');
        const currentMatches = call?.aiAssist?.priceMatches || [];
        const match = event.match || event;

        if (!match?.title) {
            return;
        }

        this.setCallAiAssist({
            status: 'ready',
            intent: event.intent || call?.aiAssist?.intent || 'price_request',
            priceMatches: [match, ...currentMatches].slice(0, 5),
            suggestedReply: event.suggestedReply || call?.aiAssist?.suggestedReply || '',
            updatedAt: new Date().toISOString(),
        });
    }

    private setCallAiAssist(aiAssist: Partial<CallAiAssistState>): void {
        const call = this.store.selectForLocal<CallDataType>('call') || defaultCallData;

        this.store.setProp<CallDataType>('call', {
            aiAssist: {
                ...defaultCallAiAssistState,
                ...(call.aiAssist || {}),
                ...aiAssist,
            },
        });
    }

    private isCurrentCallEvent(event: any): boolean {
        const currentCallSid = this.twilioService.outboundCall?.parameters?.CallSid
            || this.twilioService.inboundCall?.parameters?.CallSid;
        const currentConference = this.twilioService.outboundCall?.customParameters?.get('conf')
            || this.twilioService.inboundCall?.customParameters?.get('conf');
        const eventCallSid = event?.callSid || event?.CallSid || event?.sid;
        const eventConference = event?.conferenceSid || event?.conference || event?.conf;

        if (!eventCallSid && !eventConference) {
            return this.twilioService.isLineBusy;
        }

        return (!!eventCallSid && eventCallSid === currentCallSid)
            || (!!eventConference && eventConference === currentConference);
    }

    ngAfterViewInit() {
        this.store
            .select<boolean>('isSideBarOpen')
            .pipe(
                filter((isSideBarOpen) => isSideBarOpen === true && this.callCenterMode === 'full-screen-window'),
                takeUntil(this.destroy$)
            )
            .subscribe(() => (this.callCenterMode = 'floating-window'));
    }

    @AlertConfirmable({ title: 'Call to the number', message: 'Do you want to make a call?' })
    startCustomerCallback(callBackRow: LiveCallsRow) {
        const contact: VoiceContactData = {
            id: callBackRow.id.toString(),
            accountType: '',
            contactId: callBackRow.contactIdTo,
            contactFirstname: callBackRow.toName,
            contactSurname: '',
            contactMobile: callBackRow.from,
            contactLandline: '',
            contactEmail: '',
        };
        this.callbackPaused = false;
        this.twilioService.startOutboundCall(callBackRow.from, contact, callBackRow.sid);
    }

    showCallbackRequest(callBackRow) {
        this.toastRef = this.toastrService.success(
            `<div class="reminder-title">Callback: ${callBackRow.toName ?? callBackRow.to}</div>
                            <div class="reminder-time">${formatDistanceToNow(new Date(callBackRow.createdAt), { addSuffix: true })}</div>`,
            null,
            {
                enableHtml: true,
                timeOut: 0,
                toastClass: 'reminder-toast ngx-toastr'
            }
        );
        let timeout;
        this.toastRef.onHidden
            .pipe(take(1))
            .subscribe(item => {
                if (this.callbackPaused === true) {
                    this.callbackPaused = false;
                }  else {
                    this.callbackPaused = true;
                    // pausing callback reminders for 5 mins
                    timeout = setTimeout(() => this.callbackPaused = false, 1000 * 60 * 5);
                }
            });
        this.toastRef.onTap
            .pipe(take(1))
            .subscribe(() => {
                this.callbackPaused = true;
                clearTimeout(timeout);
                this.startCustomerCallback(callBackRow);
            });
    }

    private _initLiveCallsTable()
    {
        const translateClientId2Agent = (client) => {
            if (client.indexOf('client:') !== -1 ) {
                const clientIdentity = client.split('client:')[1];
                const callingToAgent = clientIdentity.split('-').slice(0, -1).join('-');
                const callingToAgentNumberId = clientIdentity.split('-').slice(-1)[0];
                const fromAgent = this.agentsListAll.filter(item => item.id === callingToAgent);
                if (fromAgent.length > 0) {
                    return fromAgent[0].accountType + '/' + fromAgent[0].firstname + ' ' + fromAgent[0].surname;
                }
            }
            return client;
        };
        this.tableConfig = {
            rowActions: [RowActionType.Tooltip],
            actionTooltipTemplate: this.tooltipTemplate,
            showButtons: false,
            noResultsFound: "No Calls for today",
            isFilterable: false,
            headers: [
                { name: "Id" },
                { name: "Date" },
                { name: "From" },
                { name: "To" },
                { name: "Dir" },
                { name: "Duration" },
                { name: "Status" },
                { name: "State" }
            ],
            data: this.liveCallsRows,
            properties: [
                { name: "id" },
                { name: "createdAt", isDate: true },
                { name: "fromName", translator: translateClientId2Agent },
                { name: "toName", translator: translateClientId2Agent },
                { name: "direction", isDate: false, titleCase: true },
                { name: "duration", translator: (d) => {
                    if (d) {
                        d = Number(d);
                        const h = Math.floor(d / 3600);
                        const m = Math.floor(d % 3600 / 60);
                        const s = Math.floor(d % 3600 % 60);

                        return `${h}:${m}:${s}`;
                    }
                    return '-';
                }},
                { name: "status", translator: (status) => {
                    switch (status) {
                        case (TwilioQueueStatus.default):
                            return 'Created';
                        case (TwilioQueueStatus.Initiated):
                            return 'Initiated';
                        case (TwilioQueueStatus.Waiting):
                            return 'Waiting';
                        case (TwilioQueueStatus.Talking):
                            return 'Talking';
                        case (TwilioQueueStatus.Redirect):
                            return 'Redirected';
                        case (TwilioQueueStatus.OnHold):
                            return 'On Hold';
                        case (TwilioQueueStatus.NoAgents):
                            return 'No Agent';
                        case (TwilioQueueStatus.AskCallback):
                            return 'Asking for callback';
                        case (TwilioQueueStatus.Callback):
                            return 'Asked for callback';
                        case (TwilioQueueStatus.Closed):
                            return 'Office cloed';
                        case (TwilioQueueStatus.Calling):
                            return 'Calling';
                        case (TwilioQueueStatus.NoAnswer):
                            return 'No answer';
                        case (TwilioQueueStatus.Busy):
                            return 'Busy';
                        case (TwilioQueueStatus.LeftAMessage):
                            return 'Left voice message';
                        case (TwilioQueueStatus.Error):
                            return 'Error';
                    }
                    return status;
                }},
                { name: "state", translator: (state) => {
                        switch (state) {
                            case (TwilioQueueState.default):
                                return 'Created';
                            case (TwilioQueueState.Active):
                                return 'Active';
                            case (TwilioQueueState.Busy):
                                return 'Busy';
                            case (TwilioQueueState.Done):
                                return 'Done';
                        }
                        return state;
                    }  },
            ],
        };
    }

    floatClicked($event) {
        this.inFocus = this._activeFloatTabI[0] === 1;
        $event.preventDefault();
        $event.stopPropagation();
    }

    filterAgentList(list) {
        const domainId = this.store.selectForLocal('domain');
        this.agentsListAll = list;
        const agentIds = [];
        this.agentsList = list
            .filter(item => item.domainId === domainId && item.id !== this.user.id)
            .filter(item => {
                const result = agentIds.indexOf(item.id) === -1;
                agentIds.push(item.id);
                return result;
            });

        if (this.agentFilter !== '') {
            this.filteredAgentsList = this.agentsList.filter(
                (item) =>
                    item.firstname.toLowerCase().indexOf(this.agentFilter.toLowerCase()) !== -1 ||
                    item.surname.toLowerCase().indexOf(this.agentFilter.toLowerCase()) !== -1
            );
        } else {
            this.filteredAgentsList = this.agentsList;
        }
    }

    initCallCenterView() {
        switch (this.callCenterMode) {
            case 'floating-window':
                this.twilioService.floatStyleController = this.floatTemplate;
                this.twilioService.barStyleController = null;
                this.twilioService.fullWindowController = null;
                this.inFocus = true;
                break;
            case 'bar-style':
                this.twilioService.barStyleController = this.barTemplate;
                this.twilioService.fullWindowController = null;
                this.twilioService.floatStyleController = null;
                break;
            case 'full-screen-window':
                this.twilioService.barStyleController = null;
                this.twilioService.floatStyleController = null;
                this.twilioService.fullWindowController = this.windowTemplate;
                this.menuService.sidebarOpened = false;
                this.inFocus = true;

                this.twilioService.getCallStatistics().subscribe(data => this.callStats = data);
                this.twilioService.getLiveCallsRows().subscribe(data => {
                    this.liveCallsRows = data;
                    this._initLiveCallsTable();
                });

                break;
            case 'full-screen-window--calls':
                this.twilioService.barStyleController = null;
                this.twilioService.floatStyleController = null;
                this.twilioService.fullWindowController = this.windowTemplate;
                this.menuService.sidebarOpened = false;
                this.inFocus = true;
                this.activateTab = 1;
                break;
            case 'full-screen-window--contacts':
                this.twilioService.barStyleController = null;
                this.twilioService.floatStyleController = null;
                this.twilioService.fullWindowController = this.windowTemplate;
                this.menuService.sidebarOpened = false;
                this.inFocus = true;
                this.activateTab = 2;
                break;
            case 'full-screen-window--settings':
                this.twilioService.barStyleController = null;
                this.twilioService.floatStyleController = null;
                this.twilioService.fullWindowController = this.windowTemplate;
                this.menuService.sidebarOpened = false;
                this.inFocus = true;
                this.activateTab = 5;
                break;
            case 'none':
                this.twilioService.barStyleController = null;
                this.twilioService.floatStyleController = null;
                this.twilioService.fullWindowController = null;
                break;
        }
    }

    showDialer() {
        if (this.twilioService.disabled && this.user) {
            this.twilioService.initTwilio(this.user);
        }
        this.callCenterMode = 'floating-window';
    }

    loadCustomerCalls() {
        const sub = this.twilioService
            .getCallHistoryByCId(0, 30, this.user.id, '', this.searchPhoneNr)
            .pipe(takeUntil(this.destroy$))
            .subscribe((result: { list: Array<any>; totalRecords: number }) => {
                this.callLogs = result.list;
                this.forceIntoTheBox();
            });
        this.loadCustomerCallsDebounce$.next(sub);
        this.subs$.next(sub);
    }

    loadContacts() {
        const sub = this.userService.search(this.params).subscribe((result) => {
            this.contactList = result.data.data;
            this.params.pages = Math.ceil(result.data.totalRecords / this.params.limit);
            this.params.totalRecords = result.data.totalRecords;
            this.params.pageArray = [];
            for (let i = 0; i < this.params.pages; i++) {
                this.params.pageArray.push(i);
            }
            this.forceIntoTheBox();
        });
        this.loadContactsDebounce$.next(sub);
        this.subs$.next(sub);
    }

    showOrderDetails(orderId) {
        if (this.callCenterMode === 'full-screen-window') {
            this.callCenterMode = 'floating-window';
        }
        this.router.navigate(['orders', orderId]);
    }

    redirectToAnotherAgent() {
        this.store.setProp<CallDataType>('call', { ...defaultCallDataToggle });
        this.twilioService.connectAnotherAgentToCall(this.redirect2Agent);
    }

    userSelected(user) {
        const callData = {
            firstname: user.contact.firstname,
            surname: user.contact.surname,
            contactId: user.contact.id,
            direction: 'out',
            callTo: user.contact.mobile,
        };

        this.doPhoneCallAction(callData);
    }

    doPhoneCallAction(callLog) {
        // the case when we are on the line
        const contact = {
            ...defaultVoiceContactData,
            contactId: callLog.contactId > 0 ? callLog.contactId : null,
            contactFirstname: callLog.firstname ?? null,
            contactSurname: callLog.surname ?? null,
            contactMobile: callLog.direction === 'out' ? callLog.callTo : callLog.callFrom,
        } as VoiceContactData;

        if (this.twilioService.isLineBusy) {
            this.confirmHangUp(contact);
        } else {
            this.initiateCallWithConfirmation(contact);
        }
    }

    @AlertConfirmable({ title: 'You will hang up before you can make new call?' })
    confirmHangUp(contact: VoiceContactData) {
        this.twilioService.hangUpCall();
        this.initiateCallWithConfirmation(contact);
    }

    private initiateCallWithConfirmation(contact: VoiceContactData): void {
        // for now outbound calls only to the UK making it look nice
        const name = contact.contactFirstname + (contact.contactSurname ? ' ' + contact.contactSurname : '');

        this.alertService.confirm({
            ...defaultAlertConfirmData,
            title: 'Please confirm you would like to call the following staff member',
            message: `Clicking a confirmation button 'Yes', call ${name}`,
            confirmText: 'Yes',
            confirmCb: () => this.twilioService.startOutboundCall(contact.contactMobile, contact.id ? contact : null),
        } as AlertConfirmData);
    }

    onUploadError(e) {
        console.log('onUploadError', e);
    }

    onTotalUploadProgress(event) {
        this.canPostANote = event[0] === 100;
    }

    onUploadSuccess(event) {
        this.callNoteData.files.push(event[1].data);
    }

    toggleNewCallNote() {
        this.store.setProp<CallDataType>('call', { ...defaultCallDataToggle, showNewCallNote: true });
    }

    addCallNote() {
        this.notesService
            .addNote({
                type: NoteType.Calls,
                recordId: this.twilioService.callUniqueId,
                content: this.callNoteData.content,
                files: this.callNoteData.files,
            } as Notes)
            .subscribe((note: Notes) => {
                const callNotes = this.store.selectForLocal('call').notes;
                callNotes.unshift(note);
                this.store.setProp<CallDataType>('call', { ...defaultCallDataToggle, notes: callNotes });
            });
    }

    @AlertConfirmable({ title: 'Initiate call', message: 'Do you want to make a call?' })
    makeACallAdmin(admin: TwilioAgentModel) {
        if (!this.twilioService.isLineBusy) {
            if ((!admin.inbound || admin.inbound && Date.now() > new Date(admin.inbound).getTime()) && !admin.altPhone) {
                this.alertService.error([
                    'Sorry agent is not online for inbound calls',
                ]);
            } else {
                const contact: VoiceContactData = {
                    id: admin.id,
                    accountType: admin.accountType,
                    contactId: admin.id,
                    contactFirstname: admin.firstname,
                    contactSurname: admin.surname,
                    contactMobile: admin.mobile,
                    /*contactEmail: admin.email,*/
                } as VoiceContactData;
                this.twilioService.startOutboundCallClient(admin.id + '-' + admin.numberId, admin.phone, contact);
            }
        } else {
            this.alertService.error([
                'Line is busy, please nicely finish ongoing conversation before starting the new one.',
            ]);
        }
    }

    private forceIntoTheBox() {
        const top = this.cdkDrag.getRootElement().getBoundingClientRect().top + document.body.scrollTop;

        if (top < 0) {
            this.dragPosition = this.cdkDrag.getFreeDragPosition();
            this.dragPosition.y += -1 * top;
        }
    }

    set callCenterMode(centerMode: callCenterMode) {
        if (centerMode === 'none' && this.twilioService.isLineBusy) {
            this.alertService.confirm({
                ...defaultAlertConfirmData,
                message: `Please cofirm that you will hangup this call?`,
                confirmText: 'Yes',
                confirmCb: () => {
                    this.twilioService.hangUpCall();
                    this._centerMode = centerMode;
                },
            } as AlertConfirmData);
        } else {
            this._centerMode = centerMode;
            this.initCallCenterView();
        }
    }

    get callCenterMode(): callCenterMode {
        return this._centerMode;
    }

    get activeFloatTabI(): floatTabsOnOff {
        return this._activeFloatTabI;
    }

    set activeFloatTabI(activeTabI: floatTabsOnOff) {
        if (activeTabI[1] === 1) {
            // calls log
            this.callLogs = [];
            this.callLogsParams.page = 0;
            this.loadCustomerCalls();
        }
        if (activeTabI[2] === 1 && this.contactList.length === 0) {
            // calls log
            this.loadContacts();
        }
        this._activeFloatTabI = activeTabI;
    }

    get activeTabI(): tabsOnOff {
        return this._activeTabI;
    }

    set activeTabI(activeTabI: tabsOnOff) {
        if (activeTabI[1] === 1) {
            // calls log
        }

        this._activeTabI = activeTabI;
    }

    set activateTab(tabI: number) {
        const tabs: tabsOnOff = [0, 0, 0, 0, 0, 0];
        tabs[tabI] = 1;
        this.tabMenuItems = this.tabMenuItems.map((item, index) => {
            item.active = tabs[index] === 1;
            return item;
        });
        this.activeTabI = tabs;
    }
}
